// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1B7So","messages":"Chat_messages__3cbtZ","dateDivider":"Chat_dateDivider__2-ngu"};